import api from 'api';

export const loadQlikSense = api('GET /api/qlik-sense/:id');
